<template>
    <validation-observer ref="form" v-slot="{ invalid }">
      <v-form @submit.prevent="submit" class="mb-16">
        <v-progress-linear v-if="loading" indeterminate class="global-loader"></v-progress-linear>
        <fieldset :disabled="fields.closed == true" style="border: 0;" class="elevation-0">
          <v-row>
            <!-- Lado esquerdo: câmara + preview da imagem -->
            <v-col cols="12">
                <v-row>
                    <v-col cols="12" md="2" v-if="method=='create'">
                        <v-btn class="primary" @click="openCamera">
                            Anexar fatura<v-icon>mdi-camera</v-icon>
                        </v-btn>
                    </v-col>
                    <!-- Pré-visualização da câmara -->
                    <!-- Modal da câmara -->
                    <v-dialog v-model="isCameraActive" max-width="50%">
                      <v-card class="pa-4 d-flex flex-column align-center">
                        <video ref="video" autoplay playsinline style="width: 100%; max-width: 50vw; border-radius: 8px;"></video>

                        <v-row class="mt-4" justify="center">
                          <v-btn class="success mr-4" @click="capturePhoto">Tirar Foto</v-btn>
                          <v-btn class="error" @click="stopCamera">Cancelar</v-btn>
                        </v-row>
                      </v-card>
                    </v-dialog>
                    <v-col cols="12" md="10">                       
                        <v-img
                            v-if="capturedImage"
                            :src="capturedImage"
                            class="mt-4"
                            max-width="150"
                            max-height="150"
                            contain
                            @click="dialogImage = true"
                            style="cursor: pointer"
                        />
            
                        <!-- Diálogo para imagem em tamanho grande -->
                        <v-dialog v-model="dialogImage" max-width="600">
                            <v-card>
                                <v-img :src="capturedImage" contain height="500px" />
                            </v-card>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" md="2" v-if="method == 'update' && $store.getters.hasPermission(['super', 'expenses.update'])">                      
                      <v-card class="elevation-0" outlined>
                        <v-card-title class="primary white--text">Fundo Maneio</v-card-title>
                        <v-card-text class="mt-4 text-center">{{$currency(fields.user.working_capital)}}</v-card-text>
                      </v-card>
                    </v-col>
                    
                </v-row>
            </v-col>
          </v-row>
          <v-row v-if="pegasusResponse">  
            <!-- Lado direito: campos da fatura -->
            <v-col cols="12" md="2">
              <v-autocomplete
                :disabled="method=='create'"
                :items="['Pendente', 'Paga']"
                v-model="fields.status"
                dense outlined
              />
            </v-col>
            <v-col cols="12" md="2" v-if="$store.getters.hasPermission(['super', 'expenses.update'])">
              <validation-provider v-slot="{ errors }" vid="Classificar fatura" name="Classificar fatura" rules="required">
                <v-autocomplete
                  v-model="fields.classification_id"
                  label="Tipo documento *"
                  :error-messages="errors"
                  dense
                  :items="classificacoes"
                  :item-text="item=>item.description"
                  item-value="id"
                  outlined
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="2">
              <validation-provider v-slot="{ errors }" vid="Data da Fatura" name="Data da Fatura" rules="required">
                <v-text-field
                  v-model="fields.data_fatura"
                  label="Data da Fatura *"
                  :error-messages="errors"
                  type="date"
                  dense
                  outlined
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="2">
              <validation-provider v-slot="{ errors }" vid="Nº Fatura" name="Nº Fatura" rules="required">
                <v-text-field
                  v-model="fields.n_fatura"
                  :error-messages="errors"
                  label="Nº Fatura *"
                  dense
                  outlined
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="2">
              <validation-provider v-slot="{ errors }" vid="Valor da Fatura (€)" name="Valor da Fatura (€)" rules="required">
                <v-text-field
                  type="number"
                  v-model="fields.valor_fatura"
                  prepend-inner-icon="mdi-currency-eur"
                  :error-messages="errors"
                  dense outlined
                  label="Valor da Fatura (€) *"
                  @blur="fields.valor_fatura = fields.valor_fatura == 0 ? null : fields.valor_fatura"
                  clearable
                  :locale="'en-US'"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4">
              <validation-provider v-slot="{ errors }" vid="Obra" name="Obra" rules="|">
                <v-autocomplete
                  v-model="fields.obra_id"
                  label="Obra"
                  :items="works"
                  :error-messages="errors"
                  clearable
                  :item-text="item=>item.Codigo + ' - ' + item.Descricao"
                  item-value="Id"
                  dense
                  outlined
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="2">
              <validation-provider v-slot="{ errors }" vid="Nif Fornecedor" name="Nif Fornecedor" rules="required">
                <v-text-field
                  v-model="fields.fornecedor"
                  label="Nif Fornecedor *"
                  :error-messages="errors"
                  dense
                  outlined
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="12">
              <validation-provider v-slot="{ errors }" vid="Nota" name="Nota" rules="|">
                <v-textarea
                  v-model="fields.nota"
                  label="Nota"
                  :error-messages="errors"
                  dense
                  outlined
                  rows="4"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" align="center">
              
              <v-btn :disabled="invalid" color="primary" type="submit" class="mt-4">Guardar</v-btn>
            </v-col>
          </v-row>
        </fieldset>
      </v-form>
    </validation-observer>
</template>
  
<script>
import Despesas from '@/api/Despesas.js'
import Obra from '@/api/Obra.js'

export default {
  name: "Despesas",
  props:{
    method: String,
    despesa:{
      typeof: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      dialogImage: false,
      capturedImage: null,
      pegasusResponse: false,
      isCameraActive: false,
      videoStream: null,
      fields: {
        id: null,
        n_fatura: null,
        data_fatura: null,
        valor_fatura: null,
        cc: null,
        obra_id: null,
        fornecedor: null,
        nota: null,
        status: 'Pendente'
      },
      works: [],
      classificacoes: []
    };
  },
  watch:{
    despesa:{
      immediate: true,
      handler(val){
        if(val == null)
          return

        this.fields = {...this.despesa}
        this.capturedImage = this.despesa.invoice_url
      }
    }
  },
  mounted(){
    this.fillBaseData();
  },
  methods: {
    dataURLtoBlob(dataURL) {
      const byteString = atob(dataURL.split(',')[1]);
      const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ab], { type: mimeString });
    },
    async openCamera() {
      try {
        const constraints = {
          video: { facingMode: "environment" }
        };
        this.videoStream = await navigator.mediaDevices.getUserMedia(constraints);
        this.isCameraActive = true;

        // Espera o DOM renderizar o <video> no dialog
        this.$nextTick(() => {
          this.$refs.video.srcObject = this.videoStream;
        });
      } catch (err) {
        console.error("Erro ao aceder à câmara:", err);
      }
    },
    async capturePhoto() {
      const video = this.$refs.video;
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      const dataUrl = canvas.toDataURL("image/jpeg");
      this.capturedImage = dataUrl;
      this.stopCamera();

      // Converter base64 para Blob
      const blob = this.dataURLtoBlob(dataUrl);

      // Guardar como "ficheiro" para enviar
      const file = new File([blob], "fatura.jpg", { type: "image/jpeg" });

      // Criar o FormData
      const formData = new FormData();
      formData.append("fatura", file); // o nome 'fatura' deve corresponder ao esperado no backend

      // Podes adicionar outros campos se quiseres:
      // formData.append("outro_campo", "valor");

      // Enviar para o backend
      this.loading = true
      /*await Despesas.pegasusConnection(formData).then((resp) => {
        console.log("Foto enviada com sucesso:", resp);
        this.pegasusResponse = true
        this.loading = false
      });*/
      this.pegasusResponse = true
      this.loading = false
    },
    stopCamera() {
      if (this.videoStream) {
        const tracks = this.videoStream.getTracks();
        tracks.forEach((track) => track.stop());
        this.videoStream = null;
      }
      this.isCameraActive = false;
    },

    fillBaseData() {
      Obra.all().then((resp)  =>  {
        this.works = resp.data
      })
      Despesas.getTypes().then((resp) =>  {
        this.classificacoes = resp.data
      })

      if(this.method == 'update'){
        this.loading = false
        this.pegasusResponse = true
      }
    },

    submit() {
      const formData = new FormData();
      for (const key in this.fields) {
        if (this.fields[key] !== null && this.fields[key] !== undefined) {
          formData.append(key, this.fields[key]);
        }
      }
      formData.append("fatura", this.capturedImage);

      Despesas[this.method](formData, this.fields.id).then(() => {
        if(this.method=='create') this.$router.push('/despesas')
        else window.location.reload()
      });
    }
  },
};
</script>
